// REDUCER
import * as actionTypes from '../constants/actions';

const defaultState = {
	jury: [],
	isFetching: false,
};

function juryReceived(state, payload) {
	if (typeof payload === 'object' && payload.hasOwnProperty('jury')) {
		return {...state, jury: payload.jury, prev: payload.prev, next: payload.next, total: payload.total, totalJury: payload.totalJury};
	}

	if (typeof payload === 'object' && payload.hasOwnProperty('error')) {

		let error = payload;

		return {...state, error: error, jury: []};
	}

	return state;
}

export default function juryReducer(state = defaultState, action) {
	switch (action.type) {
		case actionTypes.JURY_RECV_DATA:
			return juryReceived(state, action.payload);
		default:
			return state;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/reducers/jury.js
 **/